document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tuftzy-faq-page').forEach((section) => {
    const chips = Array.from(section.querySelectorAll('[data-faq-chip]'));
    const observedSections = Array.from(section.querySelectorAll('[data-faq-anchor-section]'));

    if (chips.length && observedSections.length && 'IntersectionObserver' in window) {
      const setActiveChip = (id) => {
        chips.forEach((chip) => {
          chip.classList.toggle('is-active', chip.dataset.faqChip === id);
        });
      };

      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntries = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

          if (visibleEntries.length) {
            setActiveChip(visibleEntries[0].target.id);
          }
        },
        {
          rootMargin: '-28% 0px -55% 0px',
          threshold: [0.15, 0.45, 0.7]
        }
      );

      observedSections.forEach((item) => observer.observe(item));
      setActiveChip(observedSections[0].id);
    }

    section.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', () => {
        const details = summary.closest('details');
        if (!details) return;

        requestAnimationFrame(() => {
          if (details.open) {
            const top = details.getBoundingClientRect().top + window.scrollY - 110;
            if (window.scrollY > top) {
              window.scrollTo({ top, behavior: 'smooth' });
            }
          }
        });
      });
    });
  });
});
